import axios from 'axios';
import { rootUrl } from '../../config/config';
import { createAuthErrorHandler } from './authSession';

const axiosInstance = axios.create({
  baseURL: rootUrl,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Same refresh path as the global axios instance: refresh once and retry, or end the session
axiosInstance.interceptors.response.use((response) => response, createAuthErrorHandler(axiosInstance));

export default axiosInstance;
